import React from 'react';
import {useExperiments} from '@wix/yoshi-flow-editor';
import {useControllerProps} from '../Widget/ControllerContext';
import {CheckoutSlot} from '../CheckoutSlot';
import {SlotId} from '../../../domain/utils/slotId';
import {classes} from './Header.st.css';
import {SPECS} from '../../../common/constants';

export const HeaderSlot: React.FC = () => {
  const {slotsStore, isOneColumnView} = useControllerProps();
  const {experiments} = useExperiments();

  const checkoutUIRevampOrderSummary = experiments.enabled(SPECS.CheckoutUIRevampOrderSummary);

  if (!slotsStore) {
    return null;
  }

  const getHeaderCheckoutSlotClassName = () => {
    if (isOneColumnView) {
      return classes.headerCheckoutSlotMobile;
    }
    return checkoutUIRevampOrderSummary ? classes.headerCheckoutSlot : classes.headerCheckoutSlotOld;
  };

  return <CheckoutSlot className={getHeaderCheckoutSlotClassName()} slotId={SlotId.HeaderCheckoutSlot} />;
};
